import { render } from "./HomeNews.vue?vue&type=template&id=61b88d94&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=61b88d94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61b88d94"

export default script